import React from 'react';
import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import DelayWrapper from '../../../containers/DelayWrapper/DelayWrapper';

import style from './LegendItem.css';
import IntervalComponent from '../Interval';
import { Interval } from '../../../types';

type LegendItemProps = {
  canExpandLegend?: boolean;
  intervals?: Interval[];
  isEditing?: boolean;
  isExpanded?: boolean;
  isFetching: boolean;
  units?: string;
  labelIntervals?: string;
  labelHigh?: string;
  labelLow?: string;
  isEditable?: boolean;
  info?: string;
  expandPanel?: () => void;
  toggleEditLegend?: () => void;
  agVizEnabled?: boolean;
};

export const LegendItem = ({
  canExpandLegend,
  intervals = [],
  isEditing,
  isExpanded,
  isFetching,
  units,
  labelIntervals,
  labelHigh,
  labelLow,
  isEditable = false,
  info,
  expandPanel,
  toggleEditLegend,
  agVizEnabled = false
}: LegendItemProps) => {
  const duration = isEditing ? 500 : 0;

  if (isFetching) {
    return (
      <DelayWrapper duration={duration}>
        <div className={`${style.legend} ${style.loadingContainer}`}>
          <div className={style.loadingContent} />
        </div>
      </DelayWrapper>
    );
  }

  return (
    <div className={style.legend}>
      {canExpandLegend && (
        <div
          className={style.legendExpandButton}
          onClick={expandPanel}
          role="button"
          tabIndex={0}
        >
          <Icon
            data-test-id="dmb-expand-legend-icon"
            glyph={isExpanded ? Icon.set.ARROW_RIGHT : Icon.set.ARROW_LEFT}
          />
        </div>
      )}
      {isEditable && (
        <div
          className={style.header}
          data-test-id="dmb-edit-legend-header"
          onClick={(e) => {
            e.stopPropagation();
            toggleEditLegend?.();
          }}
          role="button"
          tabIndex={0}
        >
          {getMessage('edit')}
        </div>
      )}
      {units && (
        <div className={style.units} data-test-id="dmb-legend-units">
          {units}
        </div>
      )}
      {(labelHigh || labelIntervals) && (
        <div className={style.legendHeader}>
          {labelIntervals && isExpanded && (
            <div className={style.labelIntervals}>{labelIntervals}</div>
          )}

          {labelHigh && (
            <div
              className={style.labelHigh}
              data-test-id="dmb-legend-label-high"
            >
              {labelHigh}
            </div>
          )}
        </div>
      )}
      <div className={style.intervals}>
        {React.Children.toArray(
          intervals.map((interval, index) => (
            <IntervalComponent
              canExpand={canExpandLegend}
              index={index}
              interval={interval}
              intervals={intervals}
              isExpanded={isExpanded}
              {...(agVizEnabled ? { agVizEnabled } : {})}
            />
          ))
        )}
      </div>
      {labelLow && (
        <div className={style.labelLow} data-test-id="dmb-legend-label-low">
          {labelLow}
        </div>
      )}
      {info && <div data-test-id="dmb-legend-info">{info}</div>}
    </div>
  )
};
